module.exports = __webpack_public_path__ + "img/Gem@3x.c2da8bfd.png";